import Icons from './icons';
export default function (options) {
    var container = options.container, volume = options.volume;
    var audio = container.querySelector('.splayer-audio');
    var mask = container.querySelector('.splayer-mask');
    var controller = container.querySelector('.splayer-controller');
    var progress = container.querySelector('.splayer-progress');
    audio.volume = volume;
    var togglePlayPause = function togglePlayPause() {
        if (audio.paused) {
            audio.play();
        } else {
            audio.pause();
        }
    };
    var updateProgress = function updateProgress() {
        progress.style.width = ''.concat(audio.currentTime / audio.duration * 100, '%');
    };
    var updateController = function updateController(isPlaying) {
        controller.innerHTML = isPlaying ? Icons.pause : Icons.play;
        controller.classList.add('splayer-animate-pulse');
        setTimeout(function () {
            return controller.classList.remove('splayer-animate-pulse');
        }, 300);
    };
    controller.onclick = togglePlayPause;
    audio.ontimeupdate = updateProgress;
    audio.onplay = function () {
        mask.removeAttribute('style');
        progress.classList.remove('splayer-progress-paused');
        updateController(true);
    };
    audio.onpause = function () {
        mask.style.opacity = 1;
        progress.classList.add('splayer-progress-paused');
        updateController(false);
    };
    audio.onended = function () {
        progress.style.width = '0';
    };
};